module.exports = "<textarea *ngIf=\"type == 'textarea'\" [style.width.px]=\"width\" [style.height.px]=\"height\" [style.maxWidth.px]=\"maxWidth\" [style.maxHeight.px]=\"maxHeight\" placeholder=\"{{placeholder}}\" class=\"wysihtml5-container\" contenteditable=\"true\" #wysihtml>\n</textarea>\n\n<div *ngIf=\"type != 'textarea'\" [style.minWidth.px]=\"width\" [style.minHeight.px]=\"height\" [style.maxWidth.px]=\"maxWidth\" [style.maxHeight.px]=\"maxHeight\" [attr.data-placeholder]=\"placeholder\" class=\"wysihtml5-container\" contenteditable=\"true\" #wysihtml>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/wysihtml-editor.component.html
// module id = 8
// module chunks = 0